<template>
  <div class="article-card">
    <v-card  class="mx-auto" color="grey lighten-4"  width="320px">
      <v-img :aspect-ratio="8/9" :src="img" :alt="title"></v-img>
      <h5 class="center bold no-link px-1">{{ title }}</h5>
      <h5 class="center no-link px-1">{{ ocupation }}</h5>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['title', 'ocupation', 'img'],
}
</script>

<style>
.article-card article {
  max-width: 336px;
  border-radius: 4px;
  background: #fff;
  display: grid;
  grid-template-rows: 200px auto;
  position: relative;
}

.article-card img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.article-card h5 {
  white-space: normal;
}
.article-card time {
  position: absolute;
  top: 8px;
  left: -4px;
  width: 60px;
  border-radius: 2px;
  display: grid;
  grid-template-rows: 60px 20px;
  padding-left: 2px;
}
.article-card .article-card-month {
  line-height: 14px !important;
}
.article-card .article-card-day {
  line-height: 18px !important;
}
</style>